@if (fieldData().readonly || tenantStore.loadingSettings()) {
    <cipo-text-view [config]="fieldData()" [value]="control().value" />
} @else {
    <mat-form-field
        class="cipo--width--full"
        [appearance]="fieldData().appearanceFill ? 'fill' : 'outline'"
        [ngClass]="{
            'cipo-mark-changed': fieldData().markChanged && valueChanged(),
        }">
        @if (fieldData().label) {
            <mat-label>{{ fieldData().label | translate }}</mat-label>
        }
        <input
            matInput
            [owlDateTimeTrigger]="datePicker"
            [owlDateTime]="datePicker"
            [selectMode]="fieldData().selectMode ?? 'single'"
            [min]="minDateOwl()"
            [max]="maxDateOwl()"
            readonly
            [formControl]="dateTimeControl" />
        @if (fieldData().hint) {
            <mat-hint>{{ fieldData().hint | translate }}</mat-hint>
        }
        @if (outerControlErrors() && controlTouched()) {
            <mat-error>
                @if (control().hasError("required")) {
                    {{ "errors.required" | translate }}
                } @else if (control().hasError("minDate")) {
                    {{
                        "errors.minDate"
                            | translate: { minDate: (fieldData().minDate | itvDateTimeCustomFormat: formattedDate()) }
                    }}
                } @else if (control().hasError("maxDate")) {
                    {{
                        "errors.maxDate"
                            | translate: { maxDate: (maxDate() | itvDateTimeCustomFormat: formattedDate()) }
                    }}
                } @else if (outerCustomError()) {
                    {{ outerCustomError() }}
                }
            </mat-error>
        }
        <div fxLayout matSuffix>
            @if (control().value && !fieldData().preventClearInput && !dateTimeControl.disabled) {
                <button
                    mat-icon-button
                    data-testid="cipo-date-time-clear"
                    [attr.aria-label]="'a11y.form.clearInput' | translate"
                    (click)="dateTimeControl.setValue(null); clearValue()">
                    <mat-icon aria-hidden="true">clear</mat-icon>
                </button>
            }
            @if (!dateTimeControl.disabled) {
                <button
                    mat-icon-button
                    [owlDateTimeTrigger]="datePicker"
                    [attr.aria-label]="'a11y.form.openCalendar' | translate">
                    <mat-icon aria-hidden="true">
                        {{ fieldData().pickerType === "time" ? "schedule" : "calendar_month" }}
                    </mat-icon>
                </button>
            }
            @if (fieldData().fieldDescription) {
                <button mat-icon-button [attr.aria-label]="fieldData().fieldDescription | translate">
                    <mat-icon aria-hidden="true" class="material-icons-outlined">info</mat-icon>
                </button>
            }
        </div>
        <owl-date-time
            #datePicker
            [pickerType]="fieldData().pickerType ? dateTimeTypeConverter[fieldData().pickerType] : 'calendar'"
            [hour12Timer]="fieldData().hour12Timer ?? tenant12hourFormat()"
            (afterPickerClosed)="resetMaxDate()"
            (dateSelected)="changed($event)"></owl-date-time>
    </mat-form-field>
}
